import { useId, type ReactNode } from 'react';
import { SectionTabs } from './SectionTabs';

/** One media-detail experience: preview first, contextual tabs, then the active workspace. */
export function MediaDetails<T extends string>({ label, preview, tabs, value, onChange, children }: {
  label: string;
  preview: ReactNode;
  tabs: readonly { id: T; label: string; icon?: ReactNode }[];
  value: T;
  onChange: (value: T) => void;
  children: ReactNode;
}) {
  const id = useId();
  return <div className="media-details">
    {preview}
    <SectionTabs id={id} label={label} className="media-details__tabs" tabs={tabs} value={value} onChange={onChange} />
    <div id={`${id}-panel-${value}`} role="tabpanel" aria-labelledby={`${id}-tab-${value}`} className="media-details__panel">{children}</div>
  </div>;
}
